import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';
import { Observable , throwError } from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import { RestUrlsConfig } from '@signature-it/ngx-generic/config';
import { ILanguage, ICmsParams } from '@signature-it/ngx-generic/interfaces';
import { HomePageCms } from '@signature-it/ngx-generic/models';

@Injectable({
	providedIn: 'root'
})
export class CmsService {

	constructor(protected http: HttpClient,
				protected restUrlsConf: RestUrlsConfig) {}

	getByTitle(title: string, lang: ILanguage, cmsPlaceHolders: ICmsParams[], cacheable: boolean): Observable<any> {
		let url = cacheable ? `${this.restUrlsConf.appURL}/public/entity/html/${title}?lang_code=${lang.code}` : `${this.restUrlsConf.appURL}/public/cms/non_cacheable/${title}?lang_code=${lang.code}`;
		let params = new HttpParams();
		if (cmsPlaceHolders) {
			params = params.append('cmsPlaceHolders', JSON.stringify(cmsPlaceHolders));
		}
		if (location.pathname) {
			let routeParams = location.href.replace(document.baseURI,'').replace(location.search, '').replace(/\//g, '-');
			params = params.delete('route');
			params = params.append('route', routeParams);
		}
		return this.http.get(url, { params })
	}

	getHomePageCms(lang: ILanguage): Observable<HomePageCms> {
		const url = `${this.restUrlsConf.appURL}/public/cms/homepage/${lang.code}`;
		return this.http.get<HomePageCms>(url)
			.pipe(map((res) => res), catchError((error: any) => throwError(error)));
	}

	getFullPageCms(title: string, lang: ILanguage): Observable<HomePageCms> {
		const url = `${this.restUrlsConf.appURL}/public/cms.json?name=${title}` + (lang ? `&lang=${lang.code}` : ``);
		return this.http.get<HomePageCms>(url)
			.pipe(map((res) => res), catchError((error: any) => throwError(error)));
	}
}
